export const bannersConstants = {
  SET_BANNERS_LOADING: 'banners/SET_BANNERS_LOADING',
  SET_BANNER_IMAGE_UPLOADING: 'banners/SET_BANNER_IMAGE_UPLOADING',
  SET_BANNER_IMAGE: 'banners/SET_BANNER_IMAGE',
  GET_BANNERS: 'banners/GET_BANNERS',
  SET_BANNERS: 'banners/SET_BANNERS',
  CLEAR_BANNERS: 'banners/CLEAR_BANNERS',
  ADD_BANNER: 'banners/ADD_BANNER',
  GET_BANNER: 'banners/GET_BANNER',
  SET_BANNER: 'banners/SET_BANNER',
  EDIT_BANNER: 'banners/EDIT_BANNER',
  EXPORT_BANNERS: 'banners/EXPORT_BANNERS',
  UPLOAD_IMAGE: 'banners/UPLOAD_IMAGE',
  UPDATE_PRIORITY: 'banners/UPDATE_PRIORITY',
};
